import { useState } from "react";
import { Text, IconButton } from "@artprov/design-system";
import PropTypes from "prop-types";
import EmailBancarioEditForm from "./EmailBancarioEditForm";
import BadgeIA from "./BadgeIA";

const DetailCard = ({
    title,
    fields = [],
    editable,
    showBadgeIA = false,
    emailBancario,
    userName,
    onSave,
    onCancel
}) => {
    const [isEditing, setIsEditing] = useState(false);

    const handleEdit = () => {
        setIsEditing(true);
    };

    const handleCancel = () => {
        setIsEditing(false);
        if (onCancel) onCancel();
    };

    const handleSave = (payload) => {
        onSave(payload);
        setIsEditing(false);
    };

    // Renderizar campo en modo lectura
    const renderReadOnlyField = (field) => (
        <div key={field.label} className="flex flex-col gap-1 break-words">
            <Text variant="body2" className="text-tertiary-60">
                {field.label}
            </Text>
            <Text variant="body2" className="text-tertiary-10 font-semibold">
                {field.value || "-"}
            </Text>
        </div>
    );

    // Modo edición: montar el formulario completo (se desmonta al cancelar/guardar)
    if (isEditing) {
        return (
            <EmailBancarioEditForm
                title={title}
                fields={fields}
                emailBancario={emailBancario}
                userName={userName}
                onSave={handleSave}
                onCancel={handleCancel}
            />
        );
    }

    // Modo lectura
    return (
        <div className="bg-tertiary-100 border border-tertiary-95 rounded py-6 px-4">
            {/* Título con badge IA y botón de editar */}
            <div className="flex justify-between items-center flex-wrap">
                <Text variant="subtitle1" className="text-primary-10">
                    {title}
                </Text>

                <div className="flex items-center gap-4">
                    {showBadgeIA && <BadgeIA />}
                    {editable && (
                        <IconButton icon="edit" size="medium" onClick={handleEdit} />
                    )}
                </div>
            </div>

            {/* Línea divisoria */}
            <div className="h-px bg-tertiary-80 my-4" />

            {/* Campos */}
            <div className="flex flex-col gap-4">
                {fields.map((field) => renderReadOnlyField(field))}
            </div>
        </div>
    );
};

DetailCard.propTypes = {
    title: PropTypes.string.isRequired,
    fields: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string,
            editable: PropTypes.bool,
            editKey: PropTypes.string,
        })
    ),
    editable: PropTypes.bool,
    showBadgeIA: PropTypes.bool,
    emailBancario: PropTypes.object,
    userName: PropTypes.string,
    onSave: PropTypes.func,
    onCancel: PropTypes.func,
};

export default DetailCard;
